import 'whatwg-fetch';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import Box from "signoxe/components/layout/Box";
import Button from "signoxe/components/widgets/Button";
import { getAsset } from 'signoxe/selectors';
import { Page } from 'signoxe/components';
import { API_ROOT } from 'signoxe/constants/config';
import {
  setAQICities, setAirvedaStations, setPageTitle,
  addAQIVedaAsset, updateAQIVedaAsset,
} from "signoxe/actions";

class AQIAirvedaPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      station: "",
    }
  }

  componentDidMount() {
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.token}`
      },
    };
    fetch(`${API_ROOT}airveda/stations`, requestOptions).then(response => {
        if (response.ok) {
          return response.json();
        }
    }).then(obj => {
      if (obj) {
        this.props.setAirvedaStations(obj);
      }
    });

    this.props.setPageTitle('Adding Airveda Asset');
  }

  render() {
    return <div className="asset-editing-page">
    <p>AQI AIRVEDA ASSET</p>
      <input type="text" placeholder="Asset name"
             value={this.state.name}
             onChange={event => this.setState({name: event.target.value})}/>
      {
        (this.props.stations.length > 0 ?
          <select
            name="station" onChange={event => this.changeSelectedStation(event.target.value)}
            value={this.state.station}
          >
            <option value="">Please choose a station</option>
            {this.props.stations.map(station => <option key={`${station}`} value={station}>{station}</option>)}
          </select> :
          <p>Loading stations...</p>
        )
      }

      <Box direction="row" justifyContent="flex-end" className="actions button-group">
        <Button primary onClick={this.saveEnabled() ? event => this.save() : null}>Save</Button>
        {/* <Button secondary onClick={event => this.props.disable()}>Cancel</Button> */}
      </Box>
    </div>
  }

  changeSelectedStation(station) {
    this.setState({station});
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.station;
  }

  cancel() {
    this.props.history.push('/assets');
  }

  save()  {
    this.props.addAQIVedaAsset({...this.state, asset_url: JSON.stringify(this.state)});
    // this.props.disable();
    setTimeout(this.props.refresh, 700)
  }

  isNewAsset() {
    return this.props.match.params.id === undefined
  };
}

const mapStateToProps = (state, ownProps) => {
  const airVedaStations = state.uiState.airVedaStations;
  return {
    stations: airVedaStations,
    token: state.authState.token
    // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: title => dispatch(setPageTitle(title)),
    setAirvedaStations: (stations) => dispatch(setAirvedaStations(stations)),

    addAQIVedaAsset: data => dispatch(addAQIVedaAsset(data)),
    updateAQIVedaAsset: (id, data) => dispatch(updateAQIVedaAsset(id, data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AQIAirvedaPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Aqi_Airveda.js